<div
  class="uber-notice__backdrop"
  [class.uber-notice__backdrop--visible]="open()"
  aria-hidden="true"
  (click)="onBackdropClick($event)"
></div>

@if (open()) {
  <section
    #dialog
    class="uber-notice"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="uber-notice-title"
    aria-describedby="uber-notice-body"
    tabindex="-1"
  >
    <div class="uber-notice__header">
      @if (mascotSrc()) {
        <img
          class="uber-notice__mascot"
          [src]="mascotSrc()"
          alt=""
          aria-hidden="true"
          loading="lazy"
          [width]="mascotWidth()"
          [height]="mascotHeight()"
        />
      }
      <div class="uber-notice__text">
        <h2 id="uber-notice-title" class="uber-notice__title">{{ title() }}</h2>
        <p id="uber-notice-body" class="uber-notice__body">{{ body() }}</p>
      </div>
    </div>

    <div class="uber-notice__actions">
      <a
        class="uber-notice__whatsapp"
        [href]="whatsappUrl()"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ whatsappLabel() }}
      </a>
      <app-button variant="primary" size="md" type="button" (click)="onAcknowledge()">
        {{ ctaLabel() }}
      </app-button>
    </div>
  </section>
}
